export enum SURVEY_QUESTION_RESPONSE_OPTIONS {
    NOT_DISAPPOINTED = 'NOT_DISAPPOINTED',
    DISAPPOINTED = 'DISAPPOINTED',
    VERY_DISAPPOINTED = 'VERY_DISAPPOINTED',
}
